// Add any new locales that must be supported by Xbox.com to this enum here
export enum Locale {
  arAE = "ar-AE",
  arSA = "ar-SA",
  csCZ = "cs-CZ",
  daDK = "da-DK",
  deAT = "de-AT",
  deCH = "de-CH",
  deDE = "de-DE",
  elGR = "el-GR",
  enAU = "en-AU",
  enCA = "en-CA",
  enGB = "en-GB",
  enHK = "en-HK",
  enIE = "en-IE",
  enIN = "en-IN",
  enMY = "en-MY",
  enNZ = "en-NZ",
  enPH = "en-PH",
  enSG = "en-SG",
  enUS = "en-US",
  enZA = "en-ZA",
  esAR = "es-AR",
  esCL = "es-CL",
  esCO = "es-CO",
  esES = "es-ES",
  esMX = "es-MX",
  fiFI = "fi-FI",
  frBE = "fr-BE",
  frCA = "fr-CA",
  frCH = "fr-CH",
  frFR = "fr-FR",
  heIL = "he-IL",
  huHU = "hu-HU",
  idID = "id-ID",
  itIT = "it-IT",
  jaJP = "ja-JP",
  koKR = "ko-KR",
  nbNO = "nb-NO",
  nlBE = "nl-BE",
  nlNL = "nl-NL",
  plPL = "pl-PL",
  ptBR = "pt-BR",
  ptPT = "pt-PT",
  ruRU = "ru-RU",
  skSK = "sk-SK",
  svSE = "sv-SE",
  thTH = "th-TH",
  trTR = "tr-TR",
  viVN = "vi-VN",
  zhCN = "zh-CN",
  zhHK = "zh-HK",
  zhTW = "zh-TW",
  ukUA = "uk-UA",
  roRO = "ro-RO",
  hrHR = "hr-HR",
  srLatnRS = "sr-Latn-RS",
  bsLatnBA = "bs-Latn-BA",
  slSI = "sl-SI",
  etEE = "et-EE",
  lvLV = "lv-LV",
  ltLT = "lt-LT",
  isIS = "is-IS",
  deLI = "de-LI",
  bgBG = "bg-BG",
  enCY = "en-CY",
  mtMT = "mt-MT",
  frLU = "fr-LU",
  deLU = "de-LU",
  sqAL = "sq-AL",
  kaGE = "ka-GE",
  mkMK = "mk-MK",
  roMD = "ro-MD",
  ruMD = "ru-MD",
  srLatnME = "sr-Latn-ME",
  esBO = "es-BO",
  esCR = "es-CR",
  esEC = "es-EC",
  esSV = "es-SV",
  esGT = "es-GT",
  esHN = "es-HN",
  esNI = "es-NI",
  esPA = "es-PA",
  esPY = "es-PY",
  esPE = "es-PE",
  esUY = "es-UY",
  arBH = "ar-BH",
  arKW = "ar-KW",
  arOM = "ar-OM",
  arQA = "ar-QA",
  arDZ = "ar-DZ",
  arEG = "ar-EG",
  arLY = "ar-LY",
  arMA = "ar-MA",
  arTN = "ar-TN",
}

export const getSupportedLocales = (enableGatedLocales: boolean) => {
  const locales = [];
  for (const locale of Object.values(Locale)) {
    if (enableGatedLocales) {
      locales.push(locale.toString().toLowerCase());
    }
  }
  return locales;
};
